import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@store/reducers";
import { EnumJobStatus2, JobStatus } from "@utils/constants";
import dayjs from "@lib/dayjs";

const JobDetailsRightPanel = () => {
  const navigate = useNavigate();
  const { jobId } = useParams();
  const { jobDetail: job } = useSelector((state: RootState) => state.job);
  const userId = useSelector((state: RootState) => state.auth.user?._id);
  const currentJob = job?._id === jobId ? job : null;
  const canEdit = currentJob && (currentJob.createdBy?._id ?? currentJob.createdBy) === userId && [JobStatus.DRAFT, JobStatus.LIVE, JobStatus.CLOSED, JobStatus.UNPUBLISHED].includes(currentJob.status);
  const date = value => value ? dayjs(value).format("DD MMM YYYY") : "Not available";
  return (
    <div className="w-[25%] rounded-md bg-white border h-max overflow-hidden">
      {/* Job basic info */}
      <div className="flex items-center relative gap-2 p-5">
        <div className="rounded-md bg-charcoal text-white text-3xl font-medium h-10 w-10 flex items-center justify-center shrink-0">
          J
        </div>
        <div className="flex flex-col gap-0.5">
          <span className="uppercase text-xss tracking-wider font-semibold text-light-black">
            Job Post
          </span>
          <span className="font-semibold text-sm">{currentJob?.title || "Job post"}</span>
          <span className="font-semibold text-content-muted text-xss">
            {currentJob?.refNo || "-"}
          </span>
          <span className="text-xss font-medium text-light-black">
            Hiring company · {currentJob?.showCompanyDetails ? currentJob?.company?.name || currentJob?.companyDetails?.name || "Company not disclosed" : "Company not disclosed"}
          </span>
        </div>
        <div className="self-start rounded-full bg-gray-100 text-xss text-content-muted font-semibold py-1 px-2">
          {EnumJobStatus2[currentJob?.status] || "Loading"}
        </div>
      </div>

      {/* Action buttons */}
      <div className="flex border-t border-light-gray flex-1 gap-2 px-5 py-3">
        <button type="button" disabled={!canEdit}
          onClick={() => navigate(`/job/create?jobId=${jobId}&step=${currentJob.status === JobStatus.DRAFT ? 1 : 2}${currentJob.status === JobStatus.DRAFT ? "" : "&mode=edit"}`)}
          className="border border-light-grey rounded-md py-2.5 flex-1 text-xss text-content-muted font-semibold disabled:opacity-50">
          Edit job
        </button>
        <button className="border border-light-grey rounded-md py-2.5 flex-1 text-xss text-content-muted font-semibold">
          Withdraw job post
        </button>
      </div>

      <div className="flex flex-col pl-5 bg-black py-4">
        <span className="text-white font-medium text-sm">
          Publishing details
        </span>
        <span className="text-light-grey text-xss">Current job post</span>
      </div>

      <div className="flex flex-col px-5 py-4 gap-5 border-b">
        <div className="grid grid-cols-[0.6fr_1.4fr] items-center">
          <span className="font-semibold text-xss text-light-black">
            Published
          </span>
          <span className=" font-semibold text-xss">{date(currentJob?.publishedDate)}</span>
        </div>
        <div className="grid grid-cols-[0.6fr_1.4fr] items-center">
          <span className="font-semibold text-xss text-light-black">
            Expires
          </span>
          <span className=" font-semibold text-xss">{date(currentJob?.expiredAt)}</span>
        </div>
        <div className="grid grid-cols-[0.6fr_1.4fr] items-center">
          <span className="font-semibold text-xss text-light-black">
            Posted by
          </span>
          <span className=" font-semibold text-xss">You</span>
        </div>
      </div>

      <div className="flex flex-col px-5 py-4">
        <span className="text-xss font-semibold uppercase tracking-widest text-light-black leading-5">Applicants</span>
        <span className="font-semibold text-2xl">{currentJob?.totalApplicants ?? currentJob?.applicantData?.length ?? 0}</span>
        <span className="text-xss font-semibold text-orange-700">{currentJob?.newApplicants ?? 0} new applications</span>
      </div>
    </div>
  );
};

export default JobDetailsRightPanel;
